module.exports = __webpack_public_path__ + "static/media/GPG292A_R92_CE.b1a69f11.jpg";